// extracted by mini-css-extract-plugin
export var changeIcon = "_3s-4";
export var container = "_3s-0";
export var divider = "_3s-7";
export var externalLinkIcon = "_3s-1";
export var green = "_3s-5";
export var helpCircleIcon = "_3s-3";
export var iconButton = "_3s-2";
export var red = "_3s-6";